import { forwardRef, Ref, SVGAttributes } from 'react'

type Props = SVGAttributes<SVGSVGElement>

const Tick = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <circle cx="12" cy="12" r="12" strokeWidth="0" />
    <path
      d="m17.5 9-7 7L7 12.5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))

export default Tick
